import { Injectable } from '@angular/core';
import {HttpCustomService} from "./http-custom.service";

@Injectable()
export class UserProfileService {

    baseUrl = 'profile/';

    constructor(
        private customHttpService: HttpCustomService,
    ) { }

    getProfiles (isExport, offset, callBack) {
        // Hardcoded 10000 to fetch all profiles, pagination causes issue in edit screen and search in view profiles list
        let path = `${this.baseUrl}profiles/?limit=10000&offset=${offset}`;
        if (isExport) {
            path += '&export=1';
        }
        this.customHttpService.fetchData(path, callBack, isExport);
    }

    getProfileDetails (id, callBack) {
        const path = this.baseUrl + id + '/';
        this.customHttpService.fetchData(path, callBack, );
    }

    getIpChoices (callBack) {
        const path = this.baseUrl + 'ip-choices/';
        this.customHttpService.fetchData(path, (response) => {
            const choices = [];
            if (response.status) {
                response.data.forEach((choice) => {
                    choices.push(
                        {
                            "value": choice,
                            "display": choice
                        }
                    )
                });
            }
            callBack(choices);
        }, );
    }

    getTechChoices (callBack) {
        const path = this.baseUrl + 'tech-choices/';
        this.customHttpService.fetchData(path, (response) => {
            const choices = [];
            if (response.status) {
                response.data.forEach((choice) => {
                    choices.push(
                        {
                            "value": choice,
                            "display": choice
                        }
                    )
                });
            }
            callBack(choices);
        }, );
    }

    createProfile (data, callBack) {
        const path = this.baseUrl + 'profiles/';
        this.customHttpService.postData(data, path, callBack, true);
    }

    editProfile (id, data, callBack) {
        const path = this.baseUrl + id + '/edit/';
        this.customHttpService.postData(data, path, callBack, true);
    }

    deleteProfile (id, callBack) {
        const path = this.baseUrl + id + '/edit/';
        this.customHttpService.deleteData(path, callBack);
    }

    importProfile (data, callBack) {
        const path = this.baseUrl + 'import/';
        this.customHttpService.postData(data, path, callBack, true);
    }

    assignEmployee (data, callBack) {
        const path = this.baseUrl + 'asign-employee/';
        this.customHttpService.postData(data, path, callBack, false);
    }

    getProfileMap (employeeId, callBack) {
        const path = this.baseUrl + 'asign-employee/';
        this.customHttpService.fetchData(path, (response) => {
            const assignedProfiles = [];
            if (response.status) {
                response.data.forEach((employeeProfiles) => {
                    if (employeeProfiles.employee_id === employeeId) {
                        employeeProfiles.profiles.forEach((profile) => {
                            assignedProfiles.push(
                                {
                                    "id": profile.id,
                                    "text": profile.name
                                }
                            );
                        });
                    }
                });
            }
            callBack(assignedProfiles);
        }, );
    }
}
